import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  deleteIcon: {
    fontSize: "1.5rem",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    cursor: "pointer",
    border: "none",
    transition: "background-color 0.1s, transform 0.1s",
    "&:hover": {
      backgroundColor: theme.palette.primary.contrastText,
      transform: "scale(1.1)",
    },
  },
  disabled: {
    opacity: 0.3,
    "&:hover": {
      transform: "none",
    },
  },
}));
